import React from 'react';
import { useParent } from '../context/ParentContext';
import ParentEmptyState from '../components/states/ParentEmptyState';
import ParentBackendPendingBanner from '../components/ParentBackendPendingBanner';
import './ParentReports.css';

function ParentReports() {
  const { currentReports, selectedStudent, demoState, hasReportsBackend } = useParent();

  if (!hasReportsBackend) {
    return (
      <div className="parent-reports">
        <h1 className="parent-page-title">Weekly Reports</h1>
        <ParentBackendPendingBanner
          state="pending"
          message="Weekly reports backend pending."
          hint="See src/parent/BACKEND_GAPS.md."
        />
      </div>
    );
  }

  if (demoState === 'empty' || currentReports.length === 0) {
    return (
      <div className="parent-reports">
        <h1 className="parent-page-title">Weekly Reports</h1>
        <ParentEmptyState variant="no-reports" />
      </div>
    );
  }

  return (
    <div className="parent-reports">
      <h1 className="parent-page-title">{selectedStudent?.firstName}'s Weekly Reports</h1>

      <div className="parent-reports__list">
        {currentReports.map(report => (
          <div key={report.id} className="parent-report-card">
            <div className="parent-report-card__header">
              <span className="parent-report-card__period">{report.periodLabel}</span>
              <span className={`parent-report-card__status parent-report-card__status--${report.overallStatus}`}>
                {formatStatus(report.overallStatus)}
              </span>
            </div>
            <p className="parent-report-card__period-dates">{report.period}</p>
            <p className="parent-report-card__summary">{report.summary}</p>

            <div className="parent-report-card__stats">
              <div className="parent-report-card__stat">
                <span className="parent-report-card__stat-label">Assignments</span>
                <span className="parent-report-card__stat-value">
                  {report.assignmentCompletion.completed}/{report.assignmentCompletion.total} ({report.assignmentCompletion.percentage}%)
                </span>
              </div>
              <div className="parent-report-card__stat">
                <span className="parent-report-card__stat-label">Most Active</span>
                <span className="parent-report-card__stat-value">{report.mostActiveCourse}</span>
              </div>
              {report.courseNeedingAttention && (
                <div className="parent-report-card__stat">
                  <span className="parent-report-card__stat-label">Needs Attention</span>
                  <span className="parent-report-card__stat-value parent-report-card__stat-value--alert">{report.courseNeedingAttention}</span>
                </div>
              )}
              <div className="parent-report-card__stat">
                <span className="parent-report-card__stat-label">Study Tools</span>
                <span className="parent-report-card__stat-value">
                  {report.studyToolActivity.quizzes} quizzes • {report.studyToolActivity.flashcards} flashcards
                </span>
              </div>
            </div>

            {report.positiveProgress && (
              <div className="parent-report-card__positive">
                <strong>Positive:</strong> {report.positiveProgress}
              </div>
            )}

            {report.suggestedAction && (
              <div className="parent-report-card__action">
                <strong>Suggested:</strong> {report.suggestedAction}
              </div>
            )}

            <div className="parent-report-card__buttons">
              <button className="parent-report-card__btn" onClick={() => window.print()}>Print Report</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function formatStatus(status) {
  const labels = { 'on-track': 'On Track', 'needs-attention': 'Needs Attention', 'at-risk': 'At Risk' };
  return labels[status] || status;
}

export default ParentReports;
